import Raven from 'raven-js';
export default (store => next => action => {
  next(action);
  // @ts-ignore fix type
  Raven.setUser(store.getState());
});